import { Routes } from "@angular/router";

export const classroomRoutes: Routes = [
  {
    path: 'classroom',
    children: [
      {
        path: '',
        loadComponent: () => import('./classroom-page/classroom-page.component').then(m => m.ClassroomPageComponent)
      },
      {
        path: 'class/:classId',
        loadComponent: () => import('./classroom-class-page/classroom-class-page.component').then(m => m.ClassroomClassPageComponent)
      },
    ],
  },
];
